import { IConfigsType } from '../../types'

const bibibopOriginalPagesConfig: IConfigsType = {
  bibibop: {
    '/:brand/expo_ai': {},
    '/:brand/corporate_team': {},
    '/:brand/corporate_loss_prevention': {},
    '/:brand/corporate_guest': {},
    '/:brand/store_detail': {},
    '/:brand/team': {},
    '/:brand/loss_prevention': {},
    '/:brand/guest': {},
  },
}

export default bibibopOriginalPagesConfig
